import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';

export const PRODUCT_COMPARE_STORAGE_KEY = 'product-comparison';
export const PRODUCT_COMPARE_MAX_DESKTOP_COUNT = 3;
export const PRODUCT_COMPARE_MAX_MOBILE_COUNT = 2;

export const API = {
    URL_PRODUCT_CLASSIFICATIONS: '/rest/v2/{site}/products/{baseProductCode}',
    URL_COMPARE_CLASSIFICATIONS: '/eshop/api/{segment}/compare',
};

if (checkShouldUseMocks({ shouldUseInTest: true })) {
    API.URL_PRODUCT_CLASSIFICATIONS = '/api/eshop/classifications';
    API.URL_COMPARE_CLASSIFICATIONS = '/api/eshop/compare';
}

export const COMPARISON_QUERY_KEYS = {
    PRODUCTS_COMPARE_FEATURES: 'products-compare-features',
};
